import { Recipe } from 'application/Shared/types/recipe';
import { TenantApp } from 'application/Shared/types/tenantApp';

import { WorkatoActions } from '../types';

export enum SaasOpsActionItemStatus {
    Completed = 'completed',
    Error = 'error',
    Pending = 'pending',
    Removed = 'removed',
    Skipped = 'skipped'
}

export enum SaasOpsActionStatus {
    Completed = 'completed',
    Stopped = 'stopped',
    InProgress = 'inProgress'
}

export interface SaasOpsActionItem {
    applicationId: string;
    workatoProvider: string;
    status: SaasOpsActionItemStatus;
    recipe: Recipe;
}

export type SaasOpsActionItemsState = SaasOpsActionItem[];

export enum WorkatoIdpProviders {
    googleWorkspace = 'google_workspace',
    microsoftEntraId = 'microsoft_entra_id_azure_active_directory_'
}

// TODO: Should this be consolidated into Admin/Workato/types.ts => WorkatoActions?
// These differ slightly since they're actions we have a dashboard flow for.
export enum WorkatoUserAction {
    Offboard = 'offboard',
    Onboard = 'onboard'
}

export type AllowedActions = Extract<
    WorkatoActions,
    WorkatoActions.offboard | WorkatoActions.onboard
>;

export interface RecipeWithTenantApp extends Recipe {
    tenantApp: TenantApp;
}
